import { useState } from 'react'
import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import { PlusIcon, MinusIcon } from '@heroicons/react/24/solid'
import { transformPaddingToTailwind } from '../../helpers/style'
import themeConfig from '../../../theme.config'

function Accordion(props) {
  const [open, setOpen] = useState({})
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  return (
    <Section type="accordion" outerClass={componentPadding} innerClass="px-7" {...props}>
      {props.accordionPanelItems.length != 0 && (
        <ul
          className={`border-b border-[color:var(--light-or-dark)] ${props.title || props.description ? 'mt-6' : ''}`}
        >
          {props.accordionPanelItems.map((item, i) => (
            <li key={i} className="border-t border-[color:var(--light-or-dark)]">
              <button
                className={`flex justify-between text-left w-full pt-6 ${open[i] ? 'pb-4' : 'pb-6'}`}
                onClick={() => {
                  setOpen((previousOpen) => {
                    if (themeConfig.settings.onlyOneAccordionOpen) {
                      const newState = { ...previousOpen }
                      newState[i] = !newState[i]
                      for (let x in newState) {
                        if (Number(x) !== Number(i)) {
                          newState[x] = false
                        }
                      }
                      return newState
                    } else {
                      return {
                        ...previousOpen,
                        [i]: !previousOpen[i],
                      }
                    }
                  })
                }}
              >
                <strong>{item.title}</strong>
                {open[i] ? (
                  <>
                    <MinusIcon className="ml-2 w-6 h-6 shrink-0" role="none" />
                    <span className="sr-only">Close Accordion</span>
                  </>
                ) : (
                  <>
                    <PlusIcon role="none" className="ml-2 w-6 h-6 shrink-0" />
                    <span className="sr-only">Open Accordion</span>
                  </>
                )}
              </button>
              {
                <div
                  data-rte="true"
                  dangerouslySetInnerHTML={createMarkup(item.content)}
                  className={`mb-6 ${open[i] ? '' : 'hidden'}`}
                />
              }
            </li>
          ))}
        </ul>
      )}
    </Section>
  )
}

export default Accordion
